import { render } from "./UpdateSurvey.vue?vue&type=template&id=a9fea75c&scoped=true&ts=true"
import script from "./UpdateSurvey.vue?vue&type=script&lang=ts"
export * from "./UpdateSurvey.vue?vue&type=script&lang=ts"

import "./UpdateSurvey.vue?vue&type=style&index=0&id=a9fea75c&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9fea75c"]])

export default __exports__